import React from 'react'

import './TextEllipsis.scss'

const baseClass = 'TextEllipsis'

type TextEllipsisOwnProps = {
    children?: React.ReactNode
    lines?: 1 | 2 | 3
    className?: string
    title?: string
}

type TextEllipsisProps<T extends React.ElementType> = TextEllipsisOwnProps & {
    as?: T
} & Omit<React.ComponentPropsWithoutRef<T>, keyof TextEllipsisOwnProps | 'as'>

const TextEllipsis = <T extends React.ElementType = 'div'>({
    children,
    lines = 1,
    className = '',
    title,
    as,
    ...props
}: TextEllipsisProps<T>) => {
    const Component = as || 'div'

    const clampedLines = Math.min(Math.max(lines, 1), 3)

    return (
        <Component
            {...props}
            className={`${baseClass} ${className}`}
            style={
                {
                    ...props.style,
                    '--text-ellipsis-lines': clampedLines,
                } as React.CSSProperties
            }
            title={title}
        >
            {children}
        </Component>
    )
}

export default TextEllipsis
